// Utilitaire de slug unifié pour les URLs (clubs, etc.)
// Règle: supprimer les accents, retirer les apostrophes, convertir espaces en tirets,
// compacter les tirets et supprimer les tirets en début/fin

export const createUrlFriendlyString = (text) => {
  if (!text) return '';
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // enlever accents
    .replace(/[\u2019']/g, '') // enlever apostrophes (droites et typographiques)
    .replace(/[^a-z0-9\s-]/g, '') // retirer autres caractères spéciaux (conserve espaces et tirets)
    .replace(/\s+/g, '-') // espaces -> tirets
    .replace(/-+/g, '-') // compacter tirets
    .replace(/^-+|-+$/g, ''); // enlever tirets début/fin
};

export const createClubUrl = (clubName) => {
  return `/clubs/${createUrlFriendlyString(clubName)}`;
};


